import { UsersDanceStylesInterface } from '../../..';
import { DanceStyleDto } from './dance-style.dto';

export class UsersDanceStylesDto implements UsersDanceStylesInterface {
  danceStyle: DanceStyleDto;
}
